import 'bootstrap';
import 'slick-carousel';
import simpleParallax from 'simple-parallax-js';

const image = document.getElementsByClassName('parallax');
new simpleParallax(image, {
    scale: 1.7,
    overflow: true,
});


import './modules/burger-rotate.js';
import './modules/form-ajax.js';
import './modules/right-nav.js';
import './modules/compare-carousel.js';